import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import FoldableTagList from '@wix/da-ds/pkg/TagList/FoldableTagList';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import License from '../../../License';
import TextRenderer from '../../../TextRenderer/TextRenderer';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import GruserZoneLocal from '../../GruserZone/Local';
import DeviationViewer from '../../../DaEditorWrapper/Viewer/Deviation';
import s from './Literature.scss';
export const LiteratureDetails = ({ deviation, deviation: { author, publishedTime, license, extended: { descriptionText, tags } = {} }, className, contentClassName })=>{
    var _descriptionText_html, _deviation_author;
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const { isSubscribedButBlocked, needsSubscription } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const isDescriptionTextShown = !!(descriptionText === null || descriptionText === void 0 ? void 0 : (_descriptionText_html = descriptionText.html) === null || _descriptionText_html === void 0 ? void 0 : _descriptionText_html.markup) && !isBlocked;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement(React.Fragment, null, tags && /*#__PURE__*/ React.createElement("div", {
        className: s['tags']
    }, /*#__PURE__*/ React.createElement(FoldableTagList, {
        tags: tags,
        moreLabel: /*#__PURE__*/ React.createElement("span", {
            title: t('common.showMore'),
            "aria-label": t('common.showMore')
        }, t('common.moreEllipsis'))
    })), isDescriptionTextShown && /*#__PURE__*/ React.createElement(TextRenderer, {
        fixedParagraph: true,
        textContent: descriptionText,
        className: s['description'],
        legacyTheme: "literature-description",
        reactViewer: DeviationViewer
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, /*#__PURE__*/ React.createElement(DeviationAttributeCSV, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['license']
    }, /*#__PURE__*/ React.createElement(License, {
        license: license,
        author: author,
        publishedTime: publishedTime,
        showSymbol: false
    })))), !isMobile && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            creatorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid
        }
    }, /*#__PURE__*/ React.createElement(GruserZoneLocal, {
        deviation: deviation
    })));
};
LiteratureDetails.displayName = 'LiteratureDetails';
export default LiteratureDetails;
